import {actionIds, BaseAction} from "../common";

const loadingUnsetAction: () =>
  BaseAction = () => ({
    type: actionIds.LOADING_UNSET,
    payload: {},
  });

export default loadingUnsetAction;
